module.exports = __webpack_public_path__ + "static/media/cherry.2d756f89.svg";